/**
 * Cargar la información de los productos químicos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function getEmpresasFil(state) {
    return state.empresas
}

/**
 * Cargar la información de los productos químicos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function getChecklist(state) {
    return state.tipoListaChequeo
}

/**
 * Generar informacion para crear data en el modulo de seguimiento.
 *
 */
export function payload(state) {
    let payload = [
        {
            company_id: state.filtro.id_empresa,
            slq_location_id: state.filtro.id_ubicacion,
            source_module: null,
            description: null,
            sys_user_id: null,
            concept: null,
            legislation: null,
            improvement_options: null,
            implement_percentage: 0,
            status: 'Creado',
        }
    ]

    if (state.plan_accion.data.hallazgos.length) {
        payload = state.plan_accion.data.hallazgos.map(item => {
            return {
                company_id: state.filtro.id_empresa,
                slq_location_id: state.filtro.id_ubicacion,
                source_module: null,
                description: item.observaciones,
                sys_user_id: item.responsable,
                concept: '',
                legislation: item.legislacion,
                improvement_options: null,
                implement_percentage: item.porcentaje_implementacion,
                status: 'Creado',
            }
        })
    };
    return payload;
}
